import axios from "axios";
import { environment } from "../../../environments/environment";

export const createRFQ = (body) => {
  return axios.post(environment.createRFQ, body);
};

export function getQuoteList(page = 0, pageSize = 10, search, sortingOrder) {
  let filterArray = [];
  const companies = JSON.parse(localStorage.getItem("u_companies"));
  let companyIds = companies.map((e) => e.id);
  filterArray.push({
    columnName: "company_id",
    value: companyIds,
  });
  return axios.post(
    `${environment.getQuoteList}?page=${page}&pageSize=${pageSize}&search=${search}&orderBy=${sortingOrder}`,
    filterArray,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

export function getPrnQuoteList(quoteId) {
  let filterArray = [];
  const companies = JSON.parse(localStorage.getItem("u_companies"));
  let companyIds = companies.map((e) => e.id);
  filterArray.push(
    {
      columnName: "company_id",
      value: companyIds,
    },
    {
      columnName: "quote_request_id",
      value: quoteId,
    }
  );
  return axios.post(
    `${
      environment.getPrnQuoteList
    }?page=${0}&pageSize=${99999}&search=${""}&orderBy=${""}`,
    filterArray,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

export function getVendorQuoteList(quoteId, prnId, part_id) {

  let filterArray = [];
  const companies = JSON.parse(localStorage.getItem("u_companies"));
  let companyIds = companies.map((e) => e.id);
  filterArray.push(
    {
      columnName: "company_id",
      value: companyIds,
    },
    {
      columnName: "quote_request_id",
      value: quoteId,
    },
    {
      columnName: "part_request_id",
      value: prnId,
    },
    {
      columnName: "part_id",
      value: part_id,
    }
  );
  return axios.post(
    `${
      environment.getVendorQuoteList
    }?page=${0}&pageSize=${99999}&search=${""}&orderBy=${""}`,
    filterArray,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}


export function getPrnQuoteModalList(quoteId, vendorId) {
  let filterArray = [];
  const companies = JSON.parse(localStorage.getItem("u_companies"));
  let companyIds = companies.map((e) => e.id);
  filterArray.push(
    {
      columnName: "company_id",
      value: companyIds,
    },
    {
      columnName: "quote_request_id",
      value: quoteId,
    },
    {
      columnName: "vendor_id",
      value: vendorId,
    }
  );
  return axios.post(
    `${
      environment.getPrnQuoteModalList
    }?page=${0}&pageSize=${99999}&search=${""}&orderBy=${""}`,
    filterArray,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}
export function getVendorQuoteModalList(quoteId) {
  let filterArray = [];
  const companies = JSON.parse(localStorage.getItem("u_companies"));
  let companyIds = companies.map((e) => e.id);
  filterArray.push(
    {
      columnName: "company_id",
      value: companyIds,
    },
    {
      columnName: "quote_request_id",
      value: quoteId,
    }
  );
  return axios.post(
    `${
      environment.getVendorQuoteModalList
    }?page=${0}&pageSize=${99999}&search=${""}&orderBy=${""}`,
    filterArray,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
}

export const getQuoteDetailById = (body) => {
  return axios.get(environment.getVendorQuoteDetailInfo+"?detailId="+ body);
};


export const updateFromQuote = (body) => {
  return axios.post(environment.updateFromQuote, body);
}